/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopFund
 */
export interface TopFund {
    /**
     * 
     * @type {string}
     * @memberof TopFund
     */
    fundName: string;
    /**
     * 
     * @type {string}
     * @memberof TopFund
     */
    fundShortName: string;
    /**
     * 
     * @type {string}
     * @memberof TopFund
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof TopFund
     */
    bookValue: string;
    /**
     * 
     * @type {string}
     * @memberof TopFund
     */
    growthPercentage: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof TopFund
     */
    fundHistory: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TopFund
     */
    fundHistoryLabels: Array<string>;
}

/**
 * Check if a given object implements the TopFund interface.
 */
export function instanceOfTopFund(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;
    isInstance = isInstance && "fundShortName" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "bookValue" in value;
    isInstance = isInstance && "growthPercentage" in value;
    isInstance = isInstance && "fundHistory" in value;
    isInstance = isInstance && "fundHistoryLabels" in value;

    return isInstance;
}

export function TopFundFromJSON(json: any): TopFund {
    return TopFundFromJSONTyped(json, false);
}

export function TopFundFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopFund {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'fundShortName': json['FundShortName'],
        'amount': json['Amount'],
        'bookValue': json['BookValue'],
        'growthPercentage': json['GrowthPercentage'],
        'fundHistory': json['FundHistory'],
        'fundHistoryLabels': json['FundHistoryLabels'],
    };
}

export function TopFundToJSON(value?: TopFund | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'FundShortName': value.fundShortName,
        'Amount': value.amount,
        'BookValue': value.bookValue,
        'GrowthPercentage': value.growthPercentage,
        'FundHistory': value.fundHistory,
        'FundHistoryLabels': value.fundHistoryLabels,
    };
}

